
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 100 125"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticStyle:{"text-indent":"0","text-align":"start","line-height":"normal","text-transform":"none","block-progression":"tb","marker":"none","-inkscape-font-specification":"Sans"},attrs:{"d":"M20 20c-7.632 0-14 5.735-14 13v34c0 7.265 6.368 13 14 13h60c7.632 0 14-5.735 14-13V33c0-7.265-6.368-13-14-13H20zm0 4h60c5.664 0 10 4.077 10 9v34c0 4.923-4.336 9-10 9H20c-5.664 0-10-4.077-10-9V33c0-4.923 4.336-9 10-9zm-3.188 8A2 2 0 0015 34v32a2 2 0 002 2h32a2 2 0 002-2V34a2 2 0 00-2-2H17a2 2 0 00-.188 0zm46 0A2.002 2.002 0 1063 36h16a2 2 0 100-4H63a2 2 0 00-.188 0zM19 36h28v28H19V36zm13.781 3.969A2 2 0 0031 42v6h-6a2 2 0 00-.188 0A2.002 2.002 0 1025 52h6v6a2 2 0 104 0v-6h6a2 2 0 100-4h-6v-6a2 2 0 00-2.219-2.031zM58.813 42A2.002 2.002 0 1059 46h24a2 2 0 100-4H59a2 2 0 00-.188 0zm0 11A2.002 2.002 0 1059 57h24a2 2 0 100-4H59a2 2 0 00-.188 0zm0 11A2.002 2.002 0 1059 68h24a2 2 0 100-4H59a2 2 0 00-.188 0z","font-weight":"400","overflow":"visible","font-family":"Sans"}})])
          )
        }
      }
    